import PptxGenJS from 'pptxgenjs';
import { defaultViewPortPadding } from '@app/services/export/ppt/variables/constants';
import { gridColWidth } from '@app/services/export/ppt/utils/gridUtils';
import IOfferBSlideData from '@app/types/data/slides/IOfferBSlideData';
import { Menu } from '@app/services/export/ppt/classes/Menu';
import PowerPointPresentation from '@app/services/export/ppt/PowerPointPresentation';
import { getChunkedListForAvailableSpace } from '@app/services/export/ppt/utils/listUtils';
import IMenuItem from '@app/types/data/base/IMenuItem';
import AbstractOfferSlideProcessor, {
	IPptOfferSlideOptions
} from '@app/services/export/ppt/slides/AbstractOfferSlideProcessor';

export default class PowerPointOfferBSlideProcessor extends AbstractOfferSlideProcessor<IOfferBSlideData> {
	public constructor(slideData: IOfferBSlideData, presentation: PowerPointPresentation) {
		const options: Partial<IPptOfferSlideOptions> = {
			imageWidth: defaultViewPortPadding.horizontal + gridColWidth(6)
		};

		super(slideData, presentation, options);
	}

	public async processSlideData(): Promise<void> {
		if (this.slideData.image) {
			await this.adjustImageDimensions(this.slideData.image);
		}

		if (this.slideData.copy) {
			this.createTextSlide(this.slideData.copy);
		}

		this.createTableSlides();

		if (this.slideData.additionalInformation) {
			this.createTextSlide(this.slideData.additionalInformation);
		}
	}

	private createTextSlide(text: string): void {
		this.updateSlideData({ copy: text });
		this.createOfferSlideBase();
	}

	private createTableSlides(): void {
		this.updateSlideData({ copy: '' });
		const { x, y, w } = this.getAvailableSpaceRectangle();

		this.getChunks().forEach(list => {
			const offerSlideBase: PptxGenJS.Slide = this.createOfferSlideBase();

			const menuTable = new Menu(
				offerSlideBase,
				{
					headline: this.slideData.listHeadline,
					list
				},
				{ x, y, w }
			);

			menuTable.create();
		});
	}

	protected getChunks(): IMenuItem[][] {
		this.updateSlideData({ copy: '' });

		return getChunkedListForAvailableSpace(<IMenuItem[]>this.slideData.list, this.getAvailableSpaceRectangle().h, {
			headerHeight: Menu.headerHeight,
			rowHeight: Menu.rowHeight
		});
	}

	protected getSlideCount(): number {
		let count = 0;
		if (this.slideData.copy) count++;
		if (this.slideData.additionalInformation) count++;
		count += this.getChunks().length;
		return count;
	}
}
